import { fetchRoadWeatherStationInfo } from "../../../../../../api/roadWeatherStationsApi"
import { changeWeatherData, showToastMessage } from "../../../../../../stateManagement/reducers"
import { store } from "../../../../../../stateManagement/store"
import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions"

export async function handleFeatureRoadWeatherStation(feature: any) {
    const [, id] = feature?.id.split('.')
    const weatherStationInfo = await fetchRoadWeatherStationInfo(id)
    if (Array.isArray(weatherStationInfo) && !weatherStationInfo.length) {
        store.dispatch(showToastMessage({ messageText: 'Ошибка получения данных метеостанции', messageType: "error", windowType: "map" }))
    } else {
        store.dispatch(changeWeatherData(weatherStationInfo))
        navigateTo(`/app/weather/${id}`)
    }
}